import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=7e3eb906"
import script from "./NotificationList.vue?vue&type=script&lang=ts"
export * from "./NotificationList.vue?vue&type=script&lang=ts"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=7e3eb906&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports